export default __webpack_public_path__ + "b52d3cdf4b11a9c60e8eb0730f8467ef.png";